<template>
  <div>
    <Nuevo :dialog="dialog" @dialog="dialog = $event" :Item="itemSelected" />
    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal -->
      <v-toolbar
        color="secondary"
        dark
        flat
        class="table-header-toolbar px-2 px-sm-3"
      >
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-factory</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              {{ Titulo || "Plantas" }}
            </div>
          </div>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="16" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Plantas
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <!-- Botón de Ayuda -->
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'plantas'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2"
                  >mdi-help-circle-outline</v-icon
                >
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <!-- Sección de Búsqueda y Acciones -->
      <div class="pa-2 pa-sm-4 pb-2">
        <div class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3">
          <!-- Búsqueda Rápida -->
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por nombre, dirección, cliente..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <!-- Botones de Acción -->
          <div class="action-buttons-group d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg mr-sm-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nueva Planta -->
            <v-btn
              v-if="
                global._autorizacion_usuario(
                  this.Permisos,
                  this.$route.meta.id,
                  ['2'],
                )
              "
              color="primary"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nueva Planta
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Indicador de desplazamiento horizontal en celular -->
      <div
        class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-1"
      >
        <v-icon x-small color="primary" class="mr-1">
          mdi-gesture-swipe-horizontal
        </v-icon>
        <span>Desliza horizontalmente para ver todos los datos</span>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="filteredCabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :mobile-breakpoint="0"
          :loading="loading"
          loading-text="Cargando plantas... Por favor, espere"
          class="modern-table elevation-0"
          no-data-text="No hay plantas disponibles"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [5, 10, 25, 50],
            'page-text': '{0}-{1} de {2}',
          }"
        >
          <!-- Columna Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center justify-center gap-1">
              <!-- Editar -->
              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Planta</span>
              </v-tooltip>

              <!-- Eliminar -->
              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['4'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="red darken-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="eliminarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Planta</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Columna Nombre de la Planta -->
          <template v-slot:[`item.nombre`]="{ item }">
            <div class="d-flex align-center">
              <v-avatar size="28" color="blue lighten-5" class="mr-2">
                <v-icon size="16" color="blue darken-2">mdi-factory</v-icon>
              </v-avatar>
              <span class="font-weight-bold text-body-2 text--primary">
                {{ item.nombre }}
              </span>
            </div>
          </template>

          <!-- Columna Dirección -->
          <template v-slot:[`item.direccion`]="{ item }">
            <div class="d-flex align-center text-body-2 text--secondary">
              <v-icon x-small color="grey darken-1" class="mr-1"
                >mdi-map-marker-outline</v-icon
              >
              <span>{{ item.direccion || "-" }}</span>
            </div>
          </template>

          <!-- Columna Cliente -->
          <template v-slot:[`item.cliente`]="{ item }">
            <div class="d-flex align-center">
              <v-icon x-small color="primary" class="mr-1">mdi-domain</v-icon>
              <span class="text-body-2 font-weight-medium text--primary">
                {{ item.cliente || "-" }}
              </span>
            </div>
          </template>

          <!-- Columna Fecha (hora:min:seg dia-mes-año) -->
          <template v-slot:[`item.fecha`]="{ item }">
            <div
              class="d-flex align-center justify-center text-caption text--secondary font-mono"
            >
              <v-icon x-small color="grey darken-1" class="mr-1"
                >mdi-clock-outline</v-icon
              >
              <span>{{ formatearFechaHora(item.fecha) }}</span>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- Modal Eliminar Planta -->
    <v-dialog v-model="dialogDelete" persistent max-width="480px">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="54" color="secondary" dark flat class="px-3 px-md-4">
          <v-icon left color="red lighten-3">mdi-alert-circle-outline</v-icon>
          <span class="text-subtitle-1 font-weight-medium">
            Confirmar Eliminación
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="dialogDelete = false"
            class="btn-circle-tooltip"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5 text-center">
          <v-avatar color="red lighten-5" size="56" class="mb-3">
            <v-icon color="red darken-2" size="32">mdi-delete-alert</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold text--primary mb-1">
            ¿Eliminar planta?
          </div>
          <div class="body-2 text--secondary">
            ¿Está seguro de que desea eliminar la planta
            <strong>"{{ itemSelected.nombre }}"</strong>? Esta acción no se
            puede deshacer.
          </div>
        </v-card-text>

        <v-card-actions
          class="pa-4 bg-light border-top d-flex justify-end align-center"
        >
          <v-btn
            outlined
            color="grey darken-1"
            class="text-capitalize px-4 rounded-lg mr-2 font-weight-medium"
            @click="dialogDelete = false"
            :disabled="loadingDelete"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="red darken-1"
            dark
            elevation="2"
            class="text-capitalize px-5 rounded-lg font-weight-bold"
            @click="confirmar()"
            :loading="loadingDelete"
          >
            <v-icon left small>mdi-delete</v-icon>
            Eliminar Planta
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import Nuevo from "./nuevo.vue";
import MensajeTransicion from "../Alerta.vue";
import global from "@/global";
import exportFromJSON from "export-from-json";
import { notif } from "@/plugins/notyf";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "loading",
    "Items",
    "Item",
    "ItemTotal",
    "Excel",
    "Crear",
  ],
  components: {
    Nuevo,
    MensajeTransicion,
  },
  data() {
    return {
      itemSelected: {},
      search: "",
      mostrarIcono: true,
      dialogDelete: false,
      dialog: false,
      mensaje: "",
      verAlerta: false,
      loadingDelete: false,
      global: global,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    canShowAccionColumn() {
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, [
        "3",
        "4",
      ]);
    },
    filteredCabecera() {
      return this.Cabecera.filter(
        (col) => !(col.value === "acciones" && !this.canShowAccionColumn),
      );
    },
  },
  methods: {
    ...mapActions("plantas", ["eliminarPlanta", "cargarPlantas"]),

    nuevoItem() {
      this.itemSelected = {
        id: null,
        nombre: null,
        direccion: null,
      };
      this.dialog = true;
    },

    editarItem(item) {
      this.itemSelected = {
        id: item.id,
        nombre: item.nombre,
        direccion: item.direccion,
      };
      this.dialog = true;
    },

    eliminarItem(item) {
      this.itemSelected = {
        id: item.id,
        nombre: item.nombre,
        direccion: item.direccion,
      };
      this.dialogDelete = true;
    },

    async confirmar() {
      try {
        this.loadingDelete = true;
        const url = "plantas/delete";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          id_planta: this.itemSelected.id,
        };

        await axios.post(url, data);
        await this.cargarPlantas();
        notif.success("Planta eliminada con éxito");
        this.dialogDelete = false;
      } catch (error) {
        this.errorMessage = error.response ? error.response.data : error;
        console.error("error!", error);
        notif.error("Error al eliminar la planta");
      } finally {
        this.loadingDelete = false;
      }
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = "plantas_" + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({
        data,
        nombreArchivo,
        exportType,
      });
    },

    formatearFechaHora(fechaStr) {
      return global.formatearFechaHora(fechaStr);
    },
  },
};
</script>

<style scoped>
.font-mono {
  font-family: monospace, "Courier New", Courier;
  letter-spacing: 0.2px;
}

.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.modern-table ::v-deep table {
  min-width: 750px;
  width: 100%;
}

.modern-table ::v-deep thead th:first-child,
.modern-table ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  background-color: #ffffff !important;
  z-index: 2 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.modern-table ::v-deep thead th:first-child {
  background-color: #424242 !important;
  z-index: 3 !important;
}

.modern-table ::v-deep tbody tr:hover td:first-child {
  background-color: #f8fafc !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 6px;
}

.gap-2 {
  gap: 8px;
}

.bg-light {
  background-color: #f8fafc;
}

.border-top {
  border-top: 1px solid #e2e8f0;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  .search-field {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
  }

  .action-buttons-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .btn-action-header {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
    margin: 0 !important;
  }

  .modern-table ::v-deep thead th {
    font-size: 0.72rem !important;
    padding: 8px 10px !important;
    height: 38px !important;
  }

  .modern-table ::v-deep td {
    font-size: 0.78rem !important;
    padding: 6px 10px !important;
  }

  .modern-table ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 6px;
    gap: 6px;
  }

  .modern-table ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .modern-table ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}
</style>
